import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PtmState {
  selectedClassIds: number[];
}

const initialState: PtmState = {
  selectedClassIds: [],
};

const ptmSlice = createSlice({
  name: "ptm",
  initialState,
  reducers: {
    setSelectedClassIds(state, action: PayloadAction<number[]>) {
      state.selectedClassIds = action.payload;
    },
    clearSelectedClassIds(state) {
      state.selectedClassIds = [];
    },
  },
});

export const {
  setSelectedClassIds,
  clearSelectedClassIds,
} = ptmSlice.actions;

export default ptmSlice.reducer;
